import * as widgetTypes from '../../utils/dashboardWidgetTypes';

/**
 * shouldShowSettingsPanel
 * helper function that returns wheter to show the settings panel
 */
export const shouldShowSettingsPanel = (widgetType, selectedMetric, selectedVisualization) => {
  switch (widgetType) {
    case widgetTypes.CAMPAIGNS_TABLE:
    case widgetTypes.MARKDOWN:
      return true;
    case widgetTypes.METRIC:
    default:
      return !!(selectedMetric && selectedVisualization);
  }
};
